// Mock data for AcrobaTisseur website

export const contactFormSubmit = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.log('Contact form submitted:', formData);
      }
      resolve({
        success: true,
        message: 'Votre message a été envoyé avec succès. Nous vous recontacterons rapidement.'
      });
    }, 1000);
  });
};

export const servicesData = [
  {
    id: 'batiment',
    title: 'Bâtiment',
    icon: 'Building2',
    description: 'Travaux en hauteur pour entretenir et réparer vos bâtiments sans installation lourde.',
    fullDescription: `Les travaux sur cordes permettent d'entretenir, de réparer & de pérenniser vos bâtiments sans immobiliser l'espace et sans installation lourde. Nos équipes interviennent directement sur les façades, toiture et structures même en accès complexe.

L'analyse de risque nous permet de vous proposer différentes solutions adaptées sur mesure. En accord avec la règlementation en vigueur sur les travaux sur cordes. Nous travaillons sur tout type de bâtiment, du patrimoine ancien aux constructions récentes, en collaboration avec les syndicats de copropriété, les collectivités locales et les acteurs du BTP.

Nous intervenons sur l'ensemble du secteur Île-de-France.`,
    features: [
      'Réparations ponctuelles (Mise hors d\'eau)',
      'Reprise de fissures',
      'Rebouche ou scellement sur façade ou toiture',
      'Restauration complète de façades',
      'Réfection des souches de cheminées',
      'Reprise des couronnements cheminés',
      'Réfection appui de fenêtre, nez de balcon',
      'Ravalement de façades et courette intérieur',
      'Traitement des éléments oxydés',
      'Traitement des pierres de moellons',
      'Intervention d\'urgence',
      'Dépose des éléments instables et dangereux (risque de chute imminente)',
      'Traitement hydrofuge des façades'
    ]
  },
  {
    id: 'peinture',
    title: 'Peinture Extérieure',
    icon: 'Paintbrush',
    description: 'Protection et esthétique de vos façades, boiseries et éléments métalliques.',
    fullDescription: `La peinture extérieur est un point essentiel de protection à la valeur du bâtiment. Avec le temps, les façades, pignons et éléments métalliques s'altèrent sous l'effet des intempéries : fissures, décoloration, infiltrations.

Une remise en peinture permet de prolonger la durée de vie de l'ouvrage et d'éviter des réparations souvent plus coûteuses et plus lourdes. Nos interventions sur cordes offrent une alternative aux échafaudages.`,
    features: [
      'Préparation des supports (Nettoyage, ponçage)',
      'Application de différentes peintures adaptées aux supports & matériaux',
      'Bois : Chien assis & garde-corps, fenêtres (Peinture acrylique)',
      'Fer : Garde-corps métalliques (Protection anti-corrosion)',
      'Balcon, Façade & couronnement (Latex et siloxane)',
      'Traitement des fissures',
      'Protection contre la décoloration',
      'Prévention des infiltrations'
    ]
  },
  {
    id: 'ouvragesTechniques',
    title: 'Ouvrages Techniques',
    icon: 'Wrench',
    description: 'Installations et réparations techniques en accès difficile.',
    fullDescription: `Nos équipes interviennent pour des installations techniques complexes en hauteur : création de verrières sur mesure, remplacement de carreaux et vitrages, installation de garde-corps et points d'ancrage certifiés, pose d'échelles crinoline, bardage et habillage de façades.

Tous nos ouvrages respectent les normes de sécurité en vigueur et sont réalisés par des cordistes qualifiés.`,
    features: [
      'Création de verrière sur mesure en structures métalliques',
      'Remplacement de carreau fenêtre ou verrière',
      'Remplacement moteurs stores défectueux',
      'Bardage bois ou aluminium sur corde',
      'Mise en place garde-corps définitif ou temporaire',
      'Pose point ancrages certifié CE',
      'Pose échelle crinoline'
    ]
  },
  {
    id: 'evenementiel',
    title: 'Événementiel',
    icon: 'Megaphone',
    description: 'Solutions publicitaires et signalétiques pour renforcer votre visibilité.',
    fullDescription: `Nos équipes interviennent aussi dans le secteur de l'événementiel pour renforcer votre visibilité au maximum. Nous proposons des solutions techniques adaptées, durables et à coûts maîtrisés.

L'accès par cordes permet une pose rapide sans échafaudage ni nacelle, minimisant l'impact sur votre activité.`,
    features: [
      'Pose d\'adhésif vinyle micro-perforé',
      'Pose de film solaire anti-UV',
      'Support publicitaire grand format',
      'Pose enseigne lumineuse LED',
      'Bâches publicitaires et habillage de chantier',
      'Visibilité extérieure / Transparence intérieure',
      'Protection complémentaire',
      'Adapté aux accès difficiles',
      'Coût maîtrisé et renouvelable',
      'Visibilité maximale jour & nuit',
      'Personnalisation complète',
      'Résistance extérieur',
      'Monétisation du chantier'
    ]
  },
  {
    id: 'securite',
    title: 'Mise en Sécurité',
    icon: 'Shield',
    description: 'Protection des personnes et des biens, conformité chantier.',
    fullDescription: `Ces interventions permettent de limiter les risques d'infiltration, les chutes de matériaux, les accidents et les dégradations, tout en assurant la conformité des ouvrages et la sécurité des personnes.`,
    features: [
      'Pose de filet anti-chute d\'homme et de pierre',
      'Sécurité des personnes',
      'Protection des tiers et des biens',
      'Conformité chantier',
      'Souplesse de mise en œuvre',
      'Réduction des coûts indirects',
      'Image professionnelle & rassurante',
      'Pose de pics anti-volatiles',
      'Empêche le perchage et nidification',
      'Protège le bâti',
      'Hygiène & Salubrité',
      'Solution discrète et durable',
      'Pose ciblée & adaptable',
      'Coût maîtrisé & entretien réduit'
    ]
  },
  {
    id: 'nettoyage',
    title: 'Nettoyage',
    icon: 'Droplets',
    description: 'Entretien régulier pour préserver l\'apparence et protéger les matériaux.',
    fullDescription: `L'entretien régulier d'un bâtiment permet de préserver l'apparence et de protéger les matériaux et d'éviter la dégradation des surfaces exposées. Nos équipes réalisent différents nettoyages en hauteur avec des méthodes modernes et utilisent des équipements adaptés afin de garantir un résultat propre, uniforme et durable. Nous intervenons sur tous type de bâtiments : résidentiel, industriel, ou public, en proposant un service complet et adapté.`,
    features: [
      'Contrat d\'entretien nettoyage chéneaux et inspection toiture',
      'Nettoyage de vitre',
      'Nettoyage de Façades (Haute pression)',
      'Nettoyage toiture (démoussage)',
      'Application d\'un traitement hydrofuge protecteur',
      'Dépoussiérage structure métallique',
      'Vérification des joints et de l\'étanchéité'
    ]
  },
  {
    id: 'toiture',
    title: 'Toiture & Couverture',
    icon: 'Home',
    description: 'Réfection, réparation et étanchéité de toitures.',
    fullDescription: `Une intervention en toiture demande souvent une connaissance du terrain et une bonne réactivité. Une bonne organisation sur zones complexes peut permettre d'agir rapidement, notamment en cas d'infiltrations ou de tuiles à remplacer. Solution adaptée en sécurisation ou de remise en état que ce soit en urgence ou en préventif.`,
    features: [
      'Réfection de solin d\'étanchéité zinc',
      'Réfection appui fenêtre zinc / couvertines',
      'Bande de noue / Bande de rives / Bande solin',
      'Traitement hydrofuge toiture & démoussage',
      'Remplacement de tuile, ardoise cassées ou déplacées',
      'Petits travaux d\'étanchéité type Viral et bande à froid',
      'Détection & Recherche de fuite sous 24 à 48 Heures'
    ]
  },
  {
    id: 'descentes',
    title: 'Descente Pluviale & Fumisterie',
    icon: 'Pipette',
    description: 'Réparation et remplacement des systèmes d\'évacuation.',
    fullDescription: `Des gouttières ou chéneaux bouchés peuvent provoquer des infiltrations importantes et traces d'humidité. Cela peut potentiellement entraînant des dégradations importantes et réparations coûteuses. Nos équipes interviennent en accès difficile pour réparer ou remplacer les systèmes d'évacuation des eaux dites fuyards.`,
    features: [
      'Remplacement descentes eaux pluviales et usées Zinc/ PVC/ Fonte/ Aluminium',
      'Création & connexion de nouveaux raccordement sur colonne',
      'Débouchage haute pression ou furet',
      'Traitement des descentes fuyards',
      'Création colonne montante EF Général'
    ]
  },
  {
    id: 'maintenance',
    title: 'Entretien & Maintenance',
    icon: 'ClipboardCheck',
    description: 'Contrats d\'entretien avec suivi précis et rapports réguliers.',
    fullDescription: `Les syndicats et gestionnaire ont besoin de visibilité sur l'état du patrimoine et sur les dépenses à venir. Le contrat d'entretien offre un suivi précis annuel, un planning d'interventions et des rapports réguliers avec préconisations si nécessaire, permettant de faciliter la prise de décisions afin de hiérarchiser par priorité les interventions.

Cette action permet aux syndicats, architectes ou maîtres d'ouvrage de pouvoir mettre en place des actions préventives et correctives afin de préserver le plus longtemps possible la viabilité du bien.`,
    features: [
      'Suivi précis annuel',
      'Planning d\'interventions',
      'Rapports réguliers avec préconisations',
      'Bâtiment propre toute l\'année',
      'Risques réduits',
      'Diagnostics réguliers',
      'Budget maîtrisé'
    ]
  }
];

export const companyInfo = {
  name: 'AcrobaTisseur',
  tagline: 'Experts en travaux acrobatiques et accès difficiles',
  description: 'AcrobaTisseur est une entreprise à taille humaine, fruit d\'une réflexion de plusieurs années. Après plus de 13 ans d\'expérience entre l\'Île de la Réunion pour des chantiers en Industrie et Travaux Public et la métropole, elle voit le jour en 2025.',
  mission: 'AcrobaTisseur a pour vocation de mettre en avant l\'expertise, l\'analyse, la rapidité, et le professionnalisme des travaux d\'accès difficiles tout en sécurité.',
  values: [
    'Satisfaction client',
    'Travail dans les règles de l\'art',
    'Préservation de votre patrimoine',
    'Discrétion et professionnalisme'
  ],
  difference: 'L\'exigence en hauteur, la précision sur le terrain',
  location: 'Basés en Essonne - Interventions sur l\'Île-de-France',
  contact: {
    email: 'acrobatisseur@gmail.com',
    phone: '07 44 75 60 47',
    address: 'Essonne, Île-de-France'
  }
};

export const stats = [
  { label: 'Ans d\'expérience', value: '13+' },
  { label: 'Services proposés', value: '6' },
  { label: 'Clients satisfaits', value: '100%' },
  { label: 'Interventions rapides', value: '24-48h' }
];
